import { render, staticRenderFns } from "./RecordingMedia.vue?vue&type=template&id=aa315cc2&scoped=true&"
import script from "./RecordingMedia.vue?vue&type=script&lang=js&"
export * from "./RecordingMedia.vue?vue&type=script&lang=js&"
import style0 from "./RecordingMedia.vue?vue&type=style&index=0&id=aa315cc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa315cc2",
  null
  
)

export default component.exports